import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import Image from 'dpl/image_cropping/components/Image.next';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

const INPUT_NAME =
  'buyer_profile_attributes.user_attributes.profile_photo_attributes';

const IMAGE_FAILED_MESSAGE = `Something went with your image. Please refresh page, or click continue to skip.`;

export default function QuizProfilePhotoQuestion({
  formState,
  handleNextClick,
  onChange,
  onSubmit,
  programName
}) {
  const profilePhoto = get(formState, INPUT_NAME, {});

  return (
    <div className="AdoptionApplicationQuizProfilePhotoQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid // optional
        title="Add a photo of you or your family (optional)"
        subtitle={`Let ${programName} put a face to your name.`}
        onSubmit={onSubmit}
      >
        <Image
          className="AdoptionApplicationQuizProfilePhotoQuestion__image"
          imageUploadClassName="bw2 b--dashed b--purple br-100 hover-bg-light-purple transition"
          photograph={profilePhoto}
          onSave={photograph => onChange(INPUT_NAME, photograph)}
          imageFailedMessage={IMAGE_FAILED_MESSAGE}
          inputName={INPUT_NAME}
        >
          <p className="transform-center-all purple f10 fw-light">+</p>
        </Image>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizProfilePhotoQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  programName: PropTypes.string.isRequired
};

QuizProfilePhotoQuestion.defaultProps = {
  onSubmit: null
};
